import { render } from "./MultiSelectTagInput.vue?vue&type=template&id=1b4524a2&scoped=true"
import script from "./MultiSelectTagInput.vue?vue&type=script&lang=js"
export * from "./MultiSelectTagInput.vue?vue&type=script&lang=js"

import "./MultiSelectTagInput.vue?vue&type=style&index=0&id=1b4524a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4524a2"]])

export default __exports__